import React, { useState } from 'react';
import axios from 'axios';
import { Search, CheckCircle2, XCircle, User, Building2, FileText } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SgTrabajadores() {
  const [rut, setRut] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const buscar = async () => {
    if (!rut.trim()) return;
    setLoading(true);
    try {
      const r = await axios.get(`${API}/servicios-generales/verificar-habilitacion`, { params: { rut } });
      setData(r.data);
    } catch { setData(null); }
    setLoading(false);
  };

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Consulta de Trabajadores</h1>
        <p className="text-sm text-slate-500">Verifica si un trabajador está habilitado para Casino y/o Hotelería.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-5">
        <div className="flex gap-2 max-w-lg">
          <input value={rut} onChange={e => setRut(e.target.value)} onKeyDown={e => e.key === 'Enter' && buscar()}
            placeholder="Ej. 12.345.678-9" className="flex-1 px-3 py-2 text-sm border border-slate-200 rounded-lg" data-testid="sg-trab-rut" />
          <button onClick={buscar} disabled={loading}
            className="px-4 py-2 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-semibold rounded-lg disabled:opacity-50" data-testid="sg-trab-buscar">
            <Search className="w-4 h-4 inline mr-1" />Buscar
          </button>
        </div>
      </div>

      {data && (
        <div className="bg-white rounded-2xl border border-slate-200 p-5" data-testid="sg-trab-result">
          {!data.encontrado ? (
            <div className="text-center py-8">
              <XCircle className="w-12 h-12 text-red-500 mx-auto mb-2" />
              <p className="text-lg font-bold text-slate-900">Trabajador no encontrado</p>
              <p className="text-sm text-slate-500">{data.motivo}</p>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-4 mb-4 pb-4 border-b border-slate-100">
                <div className="w-14 h-14 rounded-full bg-orange-600 text-white flex items-center justify-center">
                  <User className="w-7 h-7" />
                </div>
                <div>
                  <p className="text-xl font-bold text-slate-900">{data.nombre}</p>
                  <p className="text-sm text-slate-500 font-mono">{data.rut}</p>
                  <p className="text-sm text-slate-600 flex items-center gap-1 mt-1"><Building2 className="w-3.5 h-3.5" />{data.empresa_nombre}</p>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-3">
                <div className={`p-4 rounded-lg border ${data.casino_habilitado ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`}>
                  <div className="flex items-center gap-2 mb-1">
                    {data.casino_habilitado ? <CheckCircle2 className="w-6 h-6 text-emerald-600" /> : <XCircle className="w-6 h-6 text-red-600" />}
                    <p className="text-lg font-bold">Casino</p>
                  </div>
                  <p className={`text-sm font-semibold ${data.casino_habilitado ? 'text-emerald-700' : 'text-red-700'}`}>
                    {data.casino_habilitado ? 'HABILITADO' : 'NO HABILITADO'}
                  </p>
                </div>
                <div className={`p-4 rounded-lg border ${data.hoteleria_habilitado ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`}>
                  <div className="flex items-center gap-2 mb-1">
                    {data.hoteleria_habilitado ? <CheckCircle2 className="w-6 h-6 text-emerald-600" /> : <XCircle className="w-6 h-6 text-red-600" />}
                    <p className="text-lg font-bold">Hotelería</p>
                  </div>
                  <p className={`text-sm font-semibold ${data.hoteleria_habilitado ? 'text-emerald-700' : 'text-red-700'}`}>
                    {data.hoteleria_habilitado ? 'HABILITADO' : 'NO HABILITADO'}
                  </p>
                </div>
              </div>

              <div className="mt-4 flex items-start gap-2 p-3 rounded-lg bg-slate-50 text-xs text-slate-600">
                <FileText className="w-4 h-4 shrink-0 mt-0.5" />
                <p>{data.motivo}</p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
